let flowAfterNavigation: () => void = null;

export const openFlowAfterNavigation = (openFlow: () => void): void => {
    flowAfterNavigation = openFlow;
};

export const takeFlowAfterNavigation = (): (() => void) => {
    const openFlow = flowAfterNavigation;
    flowAfterNavigation = null;

    return openFlow;
};
